<template>
  <div class="mb-0" v-if="widgetSettings.showEventBanner">
    <div
      id="event-modal-header"
      class="event-header-modal"
      :class="{ noposter: !event.posterUrl }"
    >
      <div
        class="header-content col-md-8"
        :class="{ 'light-background': widgetSettings.theme !== 'dark' }"
      >
        <p class="mb-1">{{ event.organization.name }} Presents</p>
        <h4 class="font-weight-semibold mb-0">
          {{ event.name }}
        </h4>
        <event-date
          :startDate="event.eventDate"
          :endDate="event.eventEnd"
          :timezone="event.eventTimezone"
          :theme="widgetSettings.theme"
          v-if="widgetSettings.showEventTime"
        />
        <span v-if="widgetSettings.showEventLocation">
          <strong>{{ event.venueName }}</strong>
          <event-address
            :street="event.streetAddress"
            :streetTwo="event.streetAddress2"
            :city="event.city"
            :state="event.state"
            :zip="event.zip"
            :country="event.country"
          />
        </span>
        <p
          v-if="widgetSettings.showEventDescription && !isPublicApp"
          class="text-light"
          v-html="event.summary"
        ></p>
      </div>

      <div v-if="widgetSettings.showEventImage" class="header-poster">
        <div
          class="poster-image"
          v-if="event.posterMode === 'IMAGE'"
        >
          <img v-if="event.posterUrl" :src="event.posterUrl" />
        </div>
        <iframe
          v-if="event.posterMode === 'VIDEO_EMBED'"
          height="100%"
          width="100%"
          :src="parseVideoID(event.posterUrl)"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import EventDate from "./EventDate.vue";
import FormatUtils from "@/api/util/FormatUtils";
import EventAddress from "@/components/EventAddress";

export default Vue.extend({
  name: "ticket-checkout-header",
  components: { EventDate, EventAddress },
  props: ["event", "isPublicApp", "ticketEmbedSettings", "posterUrl"],
  computed: {
    widgetSettings: function() {
      const defaults = {
        showEventBanner: true,
        showEventTime: true,
        showEventLocation: true,
        showEventImage: true,
        showEventDescription: false,
        theme: "dark"
      };
      return this.isPublicApp ? defaults : this.ticketEmbedSettings;
    }
  },
  methods: {
    parseVideoID(str) {
      return FormatUtils.parseVideoURL(str);
    }
  }
});
</script>

<style>
.event-header-modal {
  display: flex;
}

.event-header-modal .header-poster {
  width: 60%;
  padding: 0;
  background: #227FC0;
}

.event-header-modal .header-poster .poster-image img {
  width: 100%;
  height: 100%;
}

.event-header-modal .header-content {
  width: 40%;
  padding: 2rem;
  color: #fff;
  background: #000000cf;
}

.event-header-modal .header-content.light-background {
  background: #fff;
}

.event-header-modal .header-content.light-background p,
.event-header-modal .header-content.light-background h4,
.event-header-modal .header-content.light-background span {
  color: black;
}

.noposter .header-poster {
  background: #000000cf;
}

@media (max-width: 990px) {
  .event-header-modal {
    display: block;
  }
  .event-header-modal .header-content {
    width: 100%;
  }

  .event-header-modal .header-poster {
    display: none;
  }
}
</style>
